import React from "react";
import { useSettings } from "../components/SettingsContext";
import { Helmet } from "react-helmet";

export default function PrivacyPolicy() {
  const { settings } = useSettings();

  return (
    <>
    <Helmet>
      <title>Privacy Policy</title>
    </Helmet>
    <div>
      <section className="page-title-area sky-blue-bg pt-160 pb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div className="page-title-wrapper text-center">
                <h4 className="styled-text theme-color mb-30">Your Privacy Matters</h4>
                <h5 className="h1 page-title">Privacy Policy</h5>
                <p className="mb-4">
                  Learn how we handle your personal data and protect your privacy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="policy-content">
                <div dangerouslySetInnerHTML={{ __html: settings?.privacy_policy || "Loading..." }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
